/**
 * ValidationError - Error class for frontend validation failures
 * 
 * This error is thrown when frontend validation fails (e.g., file upload validation,
 * form validation). It always shows as a snackbar without trace IDs since these
 * are client-side validation errors.
 */
export class ValidationError extends Error {
  public readonly field?: string;
  public readonly code?: string;

  constructor(message: string, field?: string, code?: string) {
    super(message);
    this.name = 'ValidationError';
    this.field = field;
    this.code = code;
  }

  /**
   * Check if this error is for a specific field
   */
  isFieldError(fieldName: string): boolean {
    return this.field === fieldName;
  }

  /**
   * Check if this error has a specific code
   */
  hasCode(errorCode: string): boolean {
    return this.code === errorCode;
  }
}

/**
 * Convenience function for throwing validation errors
 * @param message - The validation error message
 * @param field - Optional field name that failed validation
 * @param code - Optional error code for categorization
 */
export function throwValidationError(message: string, field?: string, code?: string): never {
  throw new ValidationError(message, field, code);
}
